import React from "react";
import { Image } from "react-native";

const ImageComponent = ({ url, style }) => {
  const defaultUrl =
    "https://squadifi-profile-pic.s3.eu-west-2.amazonaws.com/profile.svg";

  return (
    <Image
      source={{ uri: url || defaultUrl }}
      style={style}
      resizeMode="contain"
    />
  );
};

export default ImageComponent;
